import GroupObject from "../objects/group"
import HangingFixmethod from "./hanging"
import Calc from "@/common/util/calculator"
import PathObject from "@/signomatic/app/objects/path"

export default class SHookFixmethod extends HangingFixmethod {
  get visualPadding() {
    const positions = this.positions()

    if (positions.length === 1 && positions[0].center) {
      return { top: Calc.mmToPx(32), bottom: 0, left: 0, right: 0 }
    }

    return { top: Calc.mmToPx(12), bottom: 0, left: 0, right: 0 }
  }

  topDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const positions = this.positions()

    const front = this.frontHookGroup()
    const balance = this.frontHookGroup()
    balance.getObjects().forEach(o => o.set({ fill: "transparent" }))

    if (positions.length === 1 && positions[0].center) {
      // ROUND and RECT
      const frontLeft = -Calc.mmToPx(0.3)
      const frontTop = -Calc.mmToPx(11.95)
      front.set({
        left: frontLeft,
        top: frontTop,
      })
      balance.set({
        left: -frontLeft,
        top: heightPx - Calc.mmToPx(1),
      })
    } else {
      // ELLIPSE
      const hasBorder = this.drawables.hasBorder
      const radius = positions[0].diameter / 2
      const frontLeft = (positions[0].left || 0) - radius + Calc.mmToPx(1.75)
      const stainlessFrontLeft = this.state.width === 30 ? Calc.mmToPx(13.65) : Calc.mmToPx(12.65)
      let frontTop = (positions[0].top || 0) - radius - (this.isStainless ? Calc.mmToPx(10.05) : Calc.mmToPx(9.2))
      let offset = Calc.mmToPx(5.77)

      if (hasBorder) {
        const borderWidth = this.drawables.borderWidth
        frontTop = (positions[0].top || 0) - radius - Calc.mmToPx(9.2)
        const distance = this.drawables.sizeRelative("height", Calc.mmToPx(3), Calc.mmToPx(6.5))
        offset = borderWidth + distance * 1.4
      }

      front.set({
        left: this.isStainless ? stainlessFrontLeft : frontLeft,
        top: frontTop,
      })
      balance.set({
        left: frontLeft + Calc.mmToPx(1.52),
        top: heightPx - offset,
      })
    }

    items.push(front)
    items.push(balance)

    return [
      super.topDrawable()[0],
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }

  bottomDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []

    const positions = this.positions()

    const back = this.backHookGroup()
    const balance = this.backHookGroup()
    balance.getObjects().forEach(o => o.set({ fill: "transparent" }))

    if (positions.length === 1 && positions[0].center) {
      // ROUND and RECT
      const backLeft = Calc.mmToPx(1)
      const backTop = -Calc.mmToPx(33)
      back.set({
        left: backLeft,
        top: backTop,
      })
      balance.set({
        left: 0,
        top: heightPx + Calc.mmToPx(3),
      })
    } else {
      // ELLIPSE
      const hasBorder = this.drawables.hasBorder
      const backLeft = (positions[0].left || 0) + positions[0].diameter
      let backTop = -Calc.mmToPx(23)
      const frontLeft = (positions[0].left || 0) - positions[0].diameter / 2 - Calc.mmToPx(2)

      if (hasBorder) {
        const distance = this.drawables.sizeRelative("height", Calc.mmToPx(1.5), Calc.mmToPx(23))
        backTop = -Calc.mmToPx(23) + distance
      }

      back.set({
        left: backLeft,
        top: backTop,
      })
      balance.set({
        left: frontLeft + Calc.mmToPx(10),
        top: heightPx + positions[0].diameter / 2,
      })
    }

    items.push(back)
    items.push(balance)

    return new GroupObject(items, {
      left: 0,
      top: 0,
      width: widthPx,
      height: heightPx,
    })
  }

  backHookGroup() {
    const base = new PathObject(
      "M49.8,110.28l-3.39-3.59A12.2,12.2,0,0,0,49,98.75c0-5.19-2.56-9.49-6.91-13.7-3.66-3.54-8.34-6.78-13.4-10.28l-3.14-2.18C13.36,64.06,0,54.44,0,35.9,0,15,15.79,0,36.74,0S73.48,15,73.48,35.9c0,18-11.73,29.42-21.83,39.25l-1.27,1.24c-1.15,1.12-2.27,2.21-3.34,3.28L43.58,76.2l3.34-3.3,1.44-1.41C58.42,61.65,68.58,51.72,68.58,35.9c0-18.24-13.6-31-31.84-31S4.9,17.66,4.9,35.9C4.9,51.66,16,60,28.35,68.58c1,.7,2,1.39,3,2.09h0c5.06,3.5,10.14,7,14.12,10.86,4.84,4.68,8.41,10.17,8.41,17.22A17,17,0,0,1,49.8,110.28Z",
      {
        originX: "center",
        originY: "center",
        left: 0,
        top: 0,
        fill: "#74848D",
        scaleX: 1,
        scaleY: 1,
      }
    ).addClass("preview")

    const overlay = new PathObject(
      "M45.26,77.88,43.58,76.2l3.34-3.3,1.44-1.41C58.42,61.65,68.58,51.72,68.58,35.9c0-9.79-3.92-18-10.37-23.51-5.88-5.51-14-8.72-23.31-8.72C16,3.67,1.84,17,1.84,35.9c0,16.47,11.72,25.72,24,34.61l4,2.85a125.38,125.38,0,0,1,13,10.07c4.69,4.41,8,9.31,8,15.32A16.1,16.1,0,0,1,48,108.32l-1.54-1.63A12.2,12.2,0,0,0,49,98.75c0-5.19-2.56-9.49-6.91-13.7-3.66-3.54-8.34-6.78-13.4-10.28l-3.14-2.18C13.36,64.06,0,54.44,0,35.9,0,25.18,4.14,16,11,9.64A36.34,36.34,0,0,1,34.9,1.22c20.27,0,35.52,14.41,35.52,34.68,0,17.46-11.34,28.5-21.43,38.33h0l-1.31,1.27h0Z",
      {
        originX: "center",
        originY: "center",
        left: -Calc.mmToPx(0.4),
        top: -Calc.mmToPx(0.1),
        fill: "#9DA9AF",
        scaleX: 1,
        scaleY: 1,
      }
    ).addClass("preview")

    return new GroupObject([base, overlay], {
      originX: "center",
      left: 0,
      top: 0,
      width: Calc.mmToPx(26),
      height: Calc.mmToPx(39),
    })
  }

  frontHookGroup() {
    const base = new PathObject(
      "M17.17,31.67A13.64,13.64,0,0,0,21,31.14a6.79,6.79,0,0,1,2.82,4.23,18.48,18.48,0,0,1-6.6,1.2,17.72,17.72,0,0,1-11.75-4.3A16.68,16.68,0,0,1,0,19.4c0-4.1,1.34-9,2.58-12.74.63-1.9,1.26-3.55,1.74-4.74.23-.59.43-1.06.57-1.39C5,.36,5,.23,5.05.14l0-.1V0h0L7.36,1,9.6,2h0l0,.09-.14.34c-.13.3-.32.75-.54,1.31-.45,1.11-1,2.68-1.64,4.46C6,11.86,4.91,16.14,4.91,19.4a11.78,11.78,0,0,0,3.77,9.2A12.8,12.8,0,0,0,17.17,31.67Z",
      {
        originX: "center",
        originY: "center",
        left: 0,
        top: 0,
        fill: "#74848D",
        scaleX: 1,
        scaleY: 1,
      }
    )

    const overlay = new PathObject(
      "M23.1,33.52a6.89,6.89,0,0,0-1.6-2,14.6,14.6,0,0,1-6.17,1.33A14,14,0,0,1,6,29.52,13,13,0,0,1,1.84,19.4c0-3.46,1.31-8.19,2.69-12.18.68-2,1.36-3.71,1.88-5,.24-.6.45-1.08.59-1.42L5.12,0h0V0l0,.1C5,.23,5,.36,4.89.53c-.14.33-.34.8-.57,1.39C3.84,3.11,3.21,4.76,2.58,6.66,1.34,10.38,0,15.3,0,19.4A16.79,16.79,0,0,0,4.87,31.76a16.57,16.57,0,0,0,10.46,3.59A17.2,17.2,0,0,0,23.1,33.52Z",
      {
        originX: "center",
        originY: "center",
        left: -Calc.mmToPx(0.09),
        top: -Calc.mmToPx(0.15),
        fill: "#9DA9AF",
        scaleX: 1,
        scaleY: 1,
      }
    )

    return new GroupObject([base, overlay], {
      originX: "center",
      left: 0,
      top: 0,
      width: Calc.mmToPx(8.4),
      height: Calc.mmToPx(13),
    })
  }

  protected positions() {
    const pos = []
    const { widthPx, heightPx, shape } = this.state
    const hasBorder = this.drawables.hasBorder
    const borderWidth: number = this.drawables.borderWidth

    const minS = Math.min(heightPx, widthPx)
    let diameter = Math.min(Math.max(minS / 9, 8), 24)

    const center = widthPx / 2

    if (this.isStainless) {
      const top = Calc.mmToPx(3.63)
      diameter = Calc.mmToPx(3.5)

      pos.push({ left: center, top, diameter })
    } else if (shape === "rect" || shape === "round") {
      pos.push({ center: 7, diameter })
    } else if (shape === "ellipse") {
      diameter = Calc.mmToPx(5)
      const min = Calc.mmToPx(hasBorder ? 3 : 4.5)
      const max = Calc.mmToPx(6.5)

      const distance = this.drawables.sizeRelative("height", min, max)
      const top = borderWidth + distance

      pos.push({ left: center, top, diameter })
    }

    return pos
  }
}
